import React from 'react';

import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

function FacebookLoginWrapper({ render, callback, ...rest }) {
  return <FacebookLogin appId={process.env.REACT_APP_FB_ID} callback={callback} fields='name,email,picture' render={render} {...rest} />;
}

export default FacebookLoginWrapper;
